var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"icon",class:{'expanded' : _vm.expanded}},[_vm._v("keyboard_backspace")])}
var staticRenderFns = []

export { render, staticRenderFns }